/* The AutoCruise mark: a forward chevron inside an orbit - motion that keeps
   itself on course. The mark keeps its gradient (it is the logo); the
   wordmark is solid type, with "Cruise" in the one highlight colour. */
export const Mark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="ac-mark" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#6366F1" />
        <stop offset="1" stopColor="#EC4899" />
      </linearGradient>
    </defs>
    <circle cx="20" cy="20" r="17" fill="none" stroke="url(#ac-mark)" strokeWidth="2.4" strokeDasharray="78 30" strokeLinecap="round" />
    <path d="M14 13 L24 20 L14 27" fill="none" stroke="#F2F3F7" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="29" cy="20" r="2.4" fill="#EC4899" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <Mark className="w-7 h-7" />
    <span className="font-display text-[19px] font-semibold tracking-tight text-ac-text">
      Auto<span className="text-[#F472B6]">Cruise</span>
    </span>
  </span>
);
